import { fetchAllPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";

export const newRow = {
    processType : '',
    roles : [],
    status : 'ACTIVE'
}

export const getDropdownData = async (url, labelField, valueField) =>{
    try{
    const resp = await fetchAllPromisedData(url, true);
    if(resp?.code === 200) {
        const data = resp?.data?.map(item => ({...item, label : item?.[labelField], value : item?.[valueField]}));
        return data;
    }
    return [];
}catch(err) { 
    console.error(err);
}
    
}